import React from 'react';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';

function LocationSearchInput(props) {
  const { prefill, returnLatLang, inputLocation } = props;

  const [state, setState] = React.useState({ address: prefill || '' });

  const handleChange = (address) => {
    setState((prev) => ({ ...prev, address }));
  };

  const handleSelect = async (address) => {
    try {
      const results = await geocodeByAddress(address);
      setState((prev) => ({ ...prev, address: results[0].formatted_address }));
      const data = await getLatLng(results[0]);
      returnLatLang(data, state.address);
    } catch (e) {
      returnLatLang('', 'No se encotró resultado');
    }
  };

  return (
    <PlacesAutocomplete value={state.address} onChange={handleChange} onSelect={handleSelect}>
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <div>
          <input
            {...getInputProps({
              placeholder: 'Buscar ubicación ...',
              className: 'location-search-input',
            })}
            className={inputLocation !== '' ? inputLocation : 'alocation-search-input'}
          />
          <div className="autocomplete-dropdown-container">
            {loading && <div>Buscando...</div>}
            {suggestions.map((suggestion) => {
              const className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item';
              const style = suggestion.active
                ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                : { backgroundColor: '#ffffff', cursor: 'pointer' };
              return (
                <div
                  {...getSuggestionItemProps(suggestion, {
                    className,
                    style,
                  })}>
                  <span>{suggestion.description}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </PlacesAutocomplete>
  );
}

export default LocationSearchInput;
